import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";

import { getKeywordTrendLastXDays } from "../../../api/statistics/keyword/KeywordStatisticsAPI";
import { Chart, registerables } from "chart.js";
import { AlertErrorProp } from "../../../components/SnackbarNoti";
import { curveLineOptions } from "../../../util/ChartStyleUtil";
import { singleField } from "../../../util/ArrayUtil";
import { useTranslation } from "react-i18next";
Chart.register(...registerables);
type KeywordTimeProps = {
  keyword: string;
  x: number;
};

function KeywordLineChartWrapper(props: KeywordTimeProps) {
  const [keywordData, setKeywordData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const {t} = useTranslation(["common"]);
  useEffect(() => {
    getKeywordTrendLastXDays(props.keyword, props.x)
      .then((res) => {
        setKeywordData(res);
      })
      .catch(() =>
        enqueueSnackbar(t("common:load_failed_message"), AlertErrorProp as OptionsObject)
      );
  }, [props.x, props.keyword]);

  const data = {
    labels: singleField(keywordData, "day"),
    datasets: [
      {
        data: singleField(keywordData, "count"),
        label: "Số lần được nhắc đến",
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },
    ],
  };

  const options = curveLineOptions();
  options.plugins.legend.display = false;
  options.plugins.title.text = "Số lần được nhắc đến trong 10 ngày qua";

  return <Line data={data} options={options}></Line>;
}
export default KeywordLineChartWrapper;
